/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit',
	'@ba/ba-ui-carbon'
], function (
	React,
	PropTypes,
	UI_Toolkit,
	Carbon
) {
	const { Flyout } = UI_Toolkit;

	const { Button } = Carbon;

	class TabContextMenu extends React.Component {

		_renderItems(itemSpecs) {
			const items = [];
			for (let i = 0; i < itemSpecs.length; ++i) {
				items.push(this._renderItem(itemSpecs[i]));
			}
			return items;
		}

		_onSelection(event, selectedItem) {
			event.stopPropagation();
			this.props.closeFlyout();
			selectedItem.action && selectedItem.action();
		}

		_renderItem(itemSpec) {
			return (
				<Button
					className={itemSpec.className}
					size='small'
					kind='ghost'
					disabled= {itemSpec.isDisabled}
					onClick={(event) => this._onSelection(event, itemSpec)}
				>
					{itemSpec.label}
				</Button>
			);
		}

		render() {
			const {
				anchorElement,
				itemSpecs,
				closeFlyout
			} = this.props;
			const flyoutStyle = {
				'display': 'flex',
				'flex-direction': 'column'
			};
			const items = this._renderItems(itemSpecs);
			return (
				<Flyout
					onClose={ closeFlyout }
					style={flyoutStyle}
					placement= 'bottomCentred'
					domNodeToAttachTo= { document.body }
					triggerNode= { anchorElement }
					className= { 'dashboardTabContextMenu' }
				>
					{items}
				</Flyout>
			);
		}
	}

	TabContextMenu.propTypes = {
		anchorElement: PropTypes.object.isRequired,
		itemSpecs: PropTypes.arrayOf(PropTypes.object).isRequired,
		closeFlyout: PropTypes.func.isRequired
	};

	return TabContextMenu;
});